module.exports = __webpack_public_path__ + "img/writing_news-hover.421b9841.svg";